import { __ } from '@wordpress/i18n'

export default {
  select: __('Select Testimonial', 'dhsv_theme'),
  notFound: __('Testimonial not found', 'dhsv_theme'),
}
